// extracted by mini-css-extract-plugin
module.exports = {"Bg":"Hero__Bg_3Dm19","Wrapper":"Hero__Wrapper_2FSzH container","Title":"Hero__Title_2iPXJ","Lead":"Hero__Lead_31uo3 grid","Factoids":"Hero__Factoids_2uBsH"};